<div class="chat-journey-details" [class.chat-journey-details--locked]="locked">
  @if (locked && chosenSummary) {
    <div class="chat-journey-details__chosen">{{ chosenSummary }}</div>
  } @else {
    <label class="chat-journey-details__field">
      <span i18n="@@destination">Destination</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="destination"
        pattern="[A-Za-z ]+"
        placeholder="e.g. France"
        title="Enter the destination of the flight"
      />
    </label>
    <label class="chat-journey-details__field">
      <span i18n="@@mobileNum">Mobile Number</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="mobileNum"
        pattern="[\+0-9 ]+"
        placeholder="Mobile Phone Number"
        title="Enter your mobile phone number"
      />
    </label>
    <label class="chat-journey-details__field">
      <span i18n="@@outboundFlight">Outbound Flight</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="outFlight"
        pattern="[A-Za-z0-9 ]+"
        placeholder="Flight Number"
        title="Enter the flight number of the outbound flight"
      />
    </label>
    <label class="chat-journey-details__field">
      <span i18n="@@outboundTerminal">Outbound Terminal</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="outTerminal"
        placeholder="e.g. 1"
        title="Enter the terminal of the outbound flight"
      />
    </label>
    <label class="chat-journey-details__field">
      <span i18n="@@returnFlight">Return Flight</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="returnFlight"
        pattern="[A-Za-z0-9 ]+"
        placeholder="Flight Number"
        title="Enter the flight number of the return flight"
      />
    </label>
    <label class="chat-journey-details__field">
      <span i18n="@@returnTerminal">Return Terminal</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="returnTerminal"
        placeholder="e.g. 1"
        title="Enter the terminal of the return flight"
      />
    </label>

    <div class="chat-journey-details__actions">
      @if (!required) {
        <button
          type="button"
          class="chat-journey-details__skip"
          [disabled]="locked"
          (click)="onSkip()"
          i18n="@@skip"
        >
          Skip
        </button>
      }
      <button
        type="button"
        class="chat-journey-details__continue"
        [disabled]="locked || !isValid"
        (click)="onContinue()"
        i18n="@@continue"
      >
        Continue
      </button>
    </div>
  }
</div>
